// SocialSubscribe.js
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const SocialSubscribe = () => {
  return (
    <div className="social-subscribe-container d-flex justify-content-end">
      {/* Use Link component for client-side navigation */}
      <Link
        to="/subscribe"
        className="btn btn-outline-light me-3"
        style={{
          backgroundColor: '#f3d8b2',
          color: 'black',
          position: 'relative',
          top: '-8px', // Move the button 8px up
          fontWeight: '450',
        }}
      >
        Subscribe
      </Link>
      <Link
        to="/login"
        className="btn btn-outline-light me-3"
        style={{
          backgroundColor: '#f3d8b2',
          color: 'black',
          position: 'relative',
          top: '-8px', // Move the button 8px up
          fontWeight: '450',
        }}
      >
        Login
      </Link>

      {/* Social Media Icons */}
      <div className="d-flex align-items-center">
        <a
          href="https://www.facebook.com/people/Sri-Takshashila-Gurukul/pfbid09ndAnBbn9AjdzvRR84QcVNJh8zj7Eem2gQMqrPo86yC58n6L8uXJCeuamrR8GarGl/"
          className="social-icon"
          style={{ position: 'relative', top: '-5px', fontSize: '25px' }} // Make the icon size same
        >
          <i className="bi bi-facebook"></i>
        </a>
        <a
          href="https://www.instagram.com/sritakshashila/"
          className="social-icon"
          style={{ position: 'relative', top: '-5px', fontSize: '25px' }} // Make the icon size same
        >
          <i className="bi bi-instagram"></i>
        </a>
        <a
          href="https://www.whatsapp.com/channel/0029VaMRwERDuMRbNDXKsn2d"
          className="social-icon"
          style={{ position: 'relative', top: '-5px', fontSize: '25px' }} // Make the icon size same
        >
          <i className="bi bi-whatsapp"></i>
        </a>
        <a
          href="https://www.youtube.com/@SriTakshashilaGurukul"
          className="social-icon"
          style={{ position: 'relative', top: '-5px', fontSize: '25px' }} // Make the icon size same
        >
          <i className="bi bi-youtube"></i>
        </a>
        <a
          href="https://t.me/SriTakshashilaGurukul"
          className="social-icon"
          style={{ position: 'relative', top: '-5px', fontSize: '25px' }} // Make the icon size same
        >
          <i className="bi bi-telegram"></i>
        </a>
        <a
          href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQF3tPkHO3nCVAAAAZQbOS8A9Pjn3sDq_Fg4IWUyD7JJ4M7yJt75Reh4M-81pEGj82TDHRIlBpWoqb6fN-KyTHWuCDr4QYZ7-uF8UMAZGcLLNYgKEnFrJBHfWxYSfLlx_PhMlAo=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fsritakshashila-gurukul-385b41306%2F"
          className="social-icon"
          style={{ position: 'relative', top: '-5px', fontSize: '25px' }} // Make the icon size same
        >
          <i className="bi bi-linkedin"></i>
        </a>
      </div>
    </div>
  );
};

export default SocialSubscribe;
